module.exports = __webpack_public_path__ + "img/evaluate-big-icon.8604793a.png";